import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Typography } from '@finam/web-ui-kit';
import { phoneToLogin } from '../../../../utils/phone';
import { Root, Text, HiddenInput } from './LoginField.styles';

var LoginField = function LoginField(_ref) {
  var label = _ref.label,
      phone = _ref.phone;
  var login = phoneToLogin(phone || '');
  return _jsxs(Root, {
    children: [_jsx(Typography, {
      children: label
    }), _jsx(Text, {
      children: login
    }), _jsx(HiddenInput, {
      type: "text",
      name: "login",
      autoComplete: "username",
      value: login,
      readOnly: true
    })]
  });
};

export default memo(LoginField);